<template>
    <div
        class="text-multi-lines-wrapper"
        :class="{
            'text-multi-lines-wrapper--show-all': showall,
        }"
    >
        <div class="text-multi-lines-wrapper__inner">
            <slot @click.stop />
        </div>
        <div
            v-if="overflow"
            class="text-multi-lines-wrapper__ellipsis"
        >
            <span @click.stop="showAll()">
                <span
                    class="text-multi-lines-wrapper__ellipsis__text"
                >
                    {{ showall ? $t('PtCustomFieldLabelPane.multiLines.less') : $t('PtCustomFieldLabelPane.multiLines.more') }}
                </span>
                <PtIcon
                    icon="SolidDoubleArrowDown"
                    :class="{ 'query-less-icon': showall }"
                />
            </span>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/DoubleArrowDown.svg';

export default {
    name: 'MultiLinesWrapper',
    components: {
        PtIcon,
    },
    props: {
        trigger: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            // 是否溢出
            overflow: false,
            // 是否全部展示
            showall: false,
        };
    },
    watch: {
        trigger() {
            this.$nextTick(() => {
                this.check();
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.check();
        });
    },
    methods: {
        // 判断高度，判断是否溢出
        check() {
            const { height: wrapHeight } = this.$el.getBoundingClientRect();
            const { height } = this.$el.querySelector('.text-multi-lines-wrapper__inner').getBoundingClientRect();
            this.overflow = wrapHeight < height;
        },
        showAll() {
            this.showall = !this.showall;
        },
    },
};
</script>
